import * as Yup from "yup";

// Create a more flexible schema for price entries
const PriceSchema = Yup.object({
  deptId: Yup.string().required("Department is required"),
  // Only require colorId when applyToAllColors is false
  colorId: Yup.string().test(
    'conditional-required',
    'Color is required',
    function(value, context) {
      // If applyToAllColors is true, colorId can be empty or null
      if (context.parent.applyToAllColors) {
        return true;
      }
      // Otherwise colorId is required
      return !!value;
    }
  ),
  harga_internal: Yup.number().required("Price is required").min(0, "Price must be a positive number"),
  applyToAllColors: Yup.boolean().default(false),
});

const ArticleCreationSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  category: Yup.string().required("Category is required"),
  subcategory: Yup.string().required("Subcategory is required"),
  brand: Yup.string().required("Brand is required"),
  division: Yup.string().required("Division is required"),
  type: Yup.string().required("Type is required"),
  code: Yup.string().required("Code is required"),
  hpp: Yup.number().min(0, "HPP must be a positive number").default(0),
  prices: Yup.array().of(PriceSchema),
  
  // Size validation
  minSize: Yup.number()
    .min(0, "Min size must be a positive number")
    .max(99, "Min size cannot exceed 2 digits")
    .default(0),
  maxSize: Yup.number()
    .min(0, "Max size must be a positive number")
    .max(99, "Max size cannot exceed 2 digits")
    .test(
      'max-greater-than-min',
      'Max size must be greater than or equal to min size',
      function(value) {
        const minSize = this.parent.minSize;
        if (value && minSize !== undefined && minSize !== null && minSize !== '') {
          return Number(value) >= Number(minSize);
        }
        return true;
      }
    )
    .default(0),
  
  // These fields are used for preBarcode but not required in the model
  categoryCode: Yup.string(),
  subcategoryCode: Yup.string(),
  brandCode: Yup.string(),
});

export default ArticleCreationSchema;
